<template>
  <modal ref="confirm" :width="500">
    <div class="confirmation-modal-text">
      You have unsaved changes on your target.
      Are you sure you would like to disregard your changes?
    </div>
    <div slot="actions">
      <v-btn id="confirmSaveBtn" color="success" @click.native="cancelHandler">{{saveButton}}</v-btn>
      <v-btn id="confirmGoToDashboardBtn" color="light-blue lighten-1" class="white--text" @click.native="continueHandler">Continue to Dashboard</v-btn>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal'
import ActionButton from '@/components/common/actionButton'
import { SAVE_TARGET } from '@/appLogic/workbench/common/store/actions' // saving Xandr target from new workbench
import router from '@/router'
import { ACTIVATION_STATUS } from '@/appLogic/targets/Constants'
import { SET_CURRENT_TARGET, DELETE_CURRENT_TARGET } from '@/appLogic/targets/currentTarget/store/actions'
import {cloneDeep} from 'lodash'

const SAVE = 'Save'
const KEEP_WORKING = 'Keep Working'

export default {
  components: {
    Modal,
    ActionButton
  },
  props: {
    newXandrTarget: {
      type: Object
    }
  },
  data () {
    return {
      next: null,
      saveButton: SAVE,
      continueWithoutSave: true
    }
  },
  methods: {
    open (next) {
      if (next == null) {
        throw Error('You must pass the next function into this open function in order to continue on the route')
      }
      this.next = next
      this.$refs.confirm.open()
    },
    cancelHandler () {
      if (this.saveButton === SAVE) {
        this.saveButton = KEEP_WORKING
        const activation_status = this.newXandrTarget.activation_status === ACTIVATION_STATUS.DRAFT ? ACTIVATION_STATUS.WORKING : this.newXandrTarget.activation_status
        const target = {...this.newXandrTarget, activation_status: activation_status}
        this.$store.dispatch('workbench/' + SAVE_TARGET, {target})
        this.continueWithoutSave = false
      } else {
        this.$refs.confirm.close()
        this.saveButton = SAVE
      }
    },
    continueHandler () {
      if (this.continueWithoutSave && this.newXandrTarget.activation_status === ACTIVATION_STATUS.DRAFT) {
        this.deleteTarget()
      }
      this.next()
    },
    continueAfterSaveHandler () {
      this.next()
    },
    deleteTarget () {
      this.$store.dispatch(SET_CURRENT_TARGET, cloneDeep(this.newXandrTarget))
      this.$store.dispatch(DELETE_CURRENT_TARGET, this.newXandrTarget)
    }
  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// SaveWorkbenchChangesModal.vue?ae9ae812